"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _excluded = ["lighterHover"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 *  The PopupMenu component provides a dropdown menu context menu linked to a IconButton. 
 *  The menu is opened when the button is pressed. The menu is closed when clicked-away
 *  or a selection is pressed.
 *  
 *  The parent component passes in the following props:
 *  
 *  menuIcon: an Icon for the menu button, such as <MenuIcon/>
 *  menuIconStyle: an object containing style properties to apply to the icon (optional)
 *  menuTooltipText: a String containing the tooltip for the menu (optional)
 *  lighterHover: true if the menu is on top of a dark backgound (the hover over gets lighter), false for a light background (hover darker)
 *  onError: (optional) a function to call if the selectCallback function for any of the items throws, passes the item label and the error
 *  
 *  menuItems: an Array of objects representing each menu item as follows:
 *              {label: a string label for the menu item, 
                 icon: an Icon element for the menu item (optional)
                 isSelected: Boolean, whether or not the menu item is initially selected
                 selectCallback: a Function callback when the menu item is selected
                } 

                If a menuItem is null, then a Divider is inserted into the Menu    
                if the menuItems array is empty or null, the menuIcon is disabled
 *  
 * 
 */

var StyledMenu = (0, _styles.withStyles)({
  paper: {
    border: '1px solid #d3d4d5'
  }
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_core.Menu, _extends({
    elevation: 2,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, props));
});
var StyledMenuItem = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      '&:focus': {
        backgroundColor: theme.palette.primary.main,
        '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
          color: theme.palette.common.white
        }
      }
    }
  };
})(_core.MenuItem);
var LighterHoverIconButton = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      '&:hover': {
        backgroundColor: '#FFFFFF1A'
      } //go white, mostly transparent to "lighten" the background
    }
  };
})(_core.IconButton);
var PopupIcon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var lighterHover = props.lighterHover,
    otherProps = _objectWithoutProperties(props, _excluded);
  return lighterHover ? /*#__PURE__*/_react["default"].createElement(LighterHoverIconButton, _extends({
    ref: ref
  }, otherProps)) : /*#__PURE__*/_react["default"].createElement(_core.IconButton, otherProps);
});
var PopupMenu = exports.PopupMenu = /*#__PURE__*/function (_Component) {
  function PopupMenu() {
    var _this;
    _classCallCheck(this, PopupMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PopupMenu, [].concat(args));
    _defineProperty(_this, "state", {
      anchorEl: null
    });
    _defineProperty(_this, "_handleClick", function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    });
    _defineProperty(_this, "_handleClose", function () {
      _this.setState({
        anchorEl: null
      });
    });
    _defineProperty(_this, "_handleSelect", function (item) {
      _this._handleClose();
      try {
        item.selectCallback();
      } catch (error) {
        if (_this.props.onError) _this.props.onError(item.label, error);else console.log(item.label, error);
      }
    });
    return _this;
  }
  _inherits(PopupMenu, _Component);
  return _createClass(PopupMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var iconButton = /*#__PURE__*/_react["default"].createElement(PopupIcon, {
        edge: "start",
        disabled: !(this.props.menuItems && this.props.menuItems.length > 0),
        onClick: this._handleClick,
        style: this.props.menuIconStyle,
        lighterHover: this.props.lighterHover,
        color: "inherit",
        "aria-label": "menu"
      }, this.props.menuIcon);
      var renderedIconButton = this.props.menuTooltipText ? /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
        title: this.props.menuTooltipText
      }, iconButton) : iconButton;

      // Is anything selected?
      var hasSelection = false;
      var _iterator = _createForOfIteratorHelper(this.props.menuItems),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item && item.isSelected) {
            hasSelection = true;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, renderedIconButton, /*#__PURE__*/_react["default"].createElement(StyledMenu, {
        id: "lock-menu",
        anchorEl: this.state.anchorEl,
        keepMounted: true,
        selected: 2,
        disableAutoFocusItem: !hasSelection,
        open: this.state.anchorEl !== null,
        onClose: this._handleClose
      }, this.props.menuItems.map(function (item, index) {
        return item ? /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
          key: index,
          onClick: function onClick() {
            _this2._handleSelect(item);
          },
          selected: item.isSelected,
          disabled: item.isDisabled
        }, item.icon ? /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, item.icon) : null, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
          primary: item.label
        })) : /*#__PURE__*/_react["default"].createElement(_core.Divider, {
          key: index
        });
      })));
    }
  }]);
}(_react.Component);
;